module.exports = __webpack_public_path__ + "img/Pencil.837ab0fe.svg";